import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Heart, ExternalLink } from "lucide-react";

const PAYPAL_ME_HANDLE = "stivalismeschke22";
const PRESETS = [5, 10, 20, 50];

export default function TipDialog({ open, onOpenChange }) {
  const [amount, setAmount] = useState(10);
  const validAmount = amount >= 1 && amount <= 500;
  const paypalUrl = validAmount
    ? `https://www.paypal.me/${PAYPAL_ME_HANDLE}/${amount}`
    : `https://www.paypal.me/${PAYPAL_ME_HANDLE}`;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) setAmount(10); onOpenChange(v); }}>
      <DialogContent data-testid="tip-dialog" className="rounded-none border-2 border-halo-navy max-w-md">
        <DialogHeader>
          <DialogTitle className="font-sports uppercase tracking-tight text-3xl flex items-center gap-2">
            <Heart className="w-6 h-6 text-halo-red fill-halo-red" /> Tip the Podcast
          </DialogTitle>
          <DialogDescription className="font-body text-sm text-halo-navy/60">
            Every dollar keeps the postgame show on the air. You'll be sent to PayPal to complete the tip.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-2">
          <div>
            <div className="font-sports uppercase tracking-widest text-xs mb-2">Choose amount</div>
            <div className="grid grid-cols-4 gap-2">
              {PRESETS.map((p) => (
                <button
                  key={p}
                  type="button"
                  data-testid={`tip-preset-${p}`}
                  onClick={() => setAmount(p)}
                  className={`py-3 font-sports text-lg border-2 ${
                    amount === p ? "bg-halo-red border-halo-red text-white" : "border-halo-navy/20 text-halo-navy hover:border-halo-navy"
                  }`}
                >
                  ${p}
                </button>
              ))}
            </div>
            <div className="mt-3">
              <div className="font-sports uppercase tracking-widest text-xs mb-1">Custom amount</div>
              <div className="relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 font-sports text-halo-navy/60">$</span>
                <input
                  data-testid="tip-custom-amount"
                  type="number" min="1" max="500" step="1"
                  value={amount}
                  onChange={(e) => setAmount(parseFloat(e.target.value) || 0)}
                  className="w-full pl-7 pr-3 py-2 border-2 border-halo-navy/30 focus:border-halo-red focus:outline-none font-sports text-lg"
                />
              </div>
            </div>
          </div>

          {!validAmount && (
            <div className="text-xs font-body text-halo-red">Amount must be between $1 and $500.</div>
          )}

          <a
            href={paypalUrl}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="tip-paypal-link"
            className={`w-full inline-flex items-center justify-center gap-2 font-sports uppercase tracking-wider py-4 text-sm transition-colors ${
              validAmount
                ? "bg-[#0070BA] hover:bg-[#005EA6] text-white"
                : "bg-gray-200 text-gray-400 pointer-events-none"
            }`}
          >
            Send ${validAmount ? amount : "—"} on PayPal <ExternalLink className="w-4 h-4" strokeWidth={2.5} />
          </a>

          <p className="text-[11px] font-body text-halo-navy/50 text-center">
            You'll be redirected to <span className="font-sports">paypal.me/{PAYPAL_ME_HANDLE}</span> to complete the payment.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
